export default {"src":"https://assets.willie.be/c0aaa858cfc53493/_next/static/media/logo.f1dfc38e.svg","height":1169,"width":2214,"blurWidth":0,"blurHeight":0};